import { RouteObject } from 'react-router-dom';

import TrackingIconPage from '../LiveTracking/pages/TrackingIconPage';
import TrackingIconsPage from '../LiveTracking/pages/TrackingIconsPage';
import TrackingIconSchedulePage from '../LiveTracking/pages/TrackingIconSchedulePage';
import { TRACKING_ICON_SLOTS } from '../LiveTracking/models';
import { InstitutionalWeb } from '../InstitutionalWeb';
import LiveTracking from '../LiveTracking/LiveTracking';

export const InstitutionalWebRoutes: RouteObject[] = [
  {
    path: 'live-tracking/schedule',
    element: <TrackingIconSchedulePage />,
  },
  ...Object.values(TRACKING_ICON_SLOTS).flatMap((slot): RouteObject[] => [
    {
      path: `live-tracking/${slot}-icon`,
      element: <TrackingIconsPage key={slot} slot={slot} />,
    },
    {
      path: `live-tracking/${slot}-icon/create`,
      element: <TrackingIconPage slot={slot} mode='create' />,
    },
    {
      path: `live-tracking/${slot}-icon/:iconId`,
      element: <TrackingIconPage slot={slot} mode='view' />,
    },
    {
      path: `live-tracking/${slot}-icon/:iconId/edit`,
      element: <TrackingIconPage slot={slot} mode='edit' />,
    },
    {
      path: `live-tracking/${slot}-icon/:iconId/image`,
      element: <TrackingIconPage slot={slot} mode='image' />,
    },
  ]),
  {
    path: '',
    element: <InstitutionalWeb />,
  },
  {
    path: 'live-tracking',
    element: <LiveTracking />,
  },
];
